/* eslint-disable @typescript-eslint/naming-convention */
import { ColumnState } from 'ag-grid-community';

export interface TableColumnSettingsChangedEvent {
	table_definition: TableDefinition;
	column_state: ColumnState[];
}

export interface TableExportedEvent {
	table_definition: TableDefinition;
	type: ExportType;
}

export interface TableDefinition {
	table_name: DeviceManagementTableName;
	view_type?: DeviceManagementTableViewTypeMap[DeviceManagementTableName];
}

export enum DeviceManagementTableName {
	Devices = 'devices',
	Pending = 'pending',
	Jobs = 'jobs'
}

export type DeviceManagementTableViewTypeMap = {
	[DeviceManagementTableName.Devices]: 'devices' | 'connections';
	[DeviceManagementTableName.Pending]: undefined;
	[DeviceManagementTableName.Jobs]: undefined;
};

export enum ExportType {
	Csv = 'csv',
	Excel = 'excel'
}
